import { useEffect, useState } from "react";
import { FcMusic, FcCamera } from "react-icons/fc";
import firebase from "firebase";
import "firebase/storage";

const Addbeats = (props) => {
  const phone = localStorage.getItem("user-phone");
  const dpSrc = localStorage.getItem("dp-src");
  const name = localStorage.getItem("user-name");
  const storage = firebase.storage();
  const firestore = firebase.firestore();
  const [tottalAudios, setTottalAudios] = useState(false);
  const storageRef = storage.ref("users");
  const [file, setFile] = useState("");
  const [postIds, setPostIds] = useState();
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showUploadProgress, setShowUploadProgress] = useState(false);

  useEffect((e) => {
    function checkTottalAudios() {
      const array = [];
      const myRef = firestore.collection(`users/${phone}/audios`);
      myRef.get().then((docs) => {
        docs.forEach((snap) => {
          array.push(snap.data().name);
          array.length === 55 && setTottalAudios(true);
        });
      });
    }

    checkTottalAudios();
  }, []);

  function addDp(e) {
    const array = [];
    const tag = e.target;
    const file = tag.files[0];
    const type = file.type;
    const ref = storage.ref(`users/${phone}/dp/${file.name}`);
    const dpRef = storage.ref(`users/${phone}/dp`);
    dpRef.list().then((snap) => {
      const items = snap.items;

      if (type === "image/jpeg" || type === "image/png") {
        if (items.length !== 0) {
          storage.ref(items[0].fullPath).delete();
        }
        const upload = ref.put(file);
        showUploadState(upload, ref, e, "", "dp");
        alert("please Wait untill upload is done");
      } else {
        alert("oopps please choose an image");
      }
    });
  }

  function addAudio(e) {
    const file = e.target.files[0];
    if (
      file.type === "audio/mpeg" ||
      file.type === "audio/wav" ||
      file.type === "audio/ogg" ||
      file.type === "audio/m4a" ||
      file.type === "audio/x-m4a" ||
      file.type === ""
    ) {
      const ref = storage.ref(`users/${phone}/audios/${file.name}`);
      const upload = ref.put(file);

      showUploadState(upload, ref, e, file.name, "audio");
      alert("please Wait untill upload is done");
    } else {
      alert("please choose an audio file  ");
    }
  }

  function showUploadState(upload, storageRef, e, fileName, funcName) {
    upload.on(
      "state_changed",
      (snap) => {
        setShowUploadProgress(true);
        const percentage = (
          (snap.bytesTransferred / snap.totalBytes) *
          100
        ).toFixed(0);
        setUploadProgress(percentage);
      },
      (err) => {
        alert("oops an error occured");
      },
      async () => {
        const url = await storageRef.getDownloadURL();

        if (funcName === "audio") {
          const firestoreRef = firestore.doc(
            `users/${phone}/audios/${fileName}`
          );
          const allAudioRef = firestore.doc(`allAudios/${fileName}`);

          const theAudioInfo = {
            dp: dpSrc,
            name: name,
            phone: phone,
            src: url,
            audioName: fileName,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            likes: [phone],
          };
          const myRef = firestore.doc(`users/${phone}`);

          myRef.get().then((snap) => {
            const followers = snap.data().followers;
            followers.forEach((n) => {
              const ref = firestore.doc(`users/${n}/bucket/${fileName}`);
              const myBucket = firestore.doc(
                `users/${phone}/bucket/${fileName}`
              );
              ref.set(theAudioInfo);
              myBucket.set(theAudioInfo);
            });
          });
          firestoreRef.set(theAudioInfo);

          alert("upload is a success");
        }

        if (funcName === "dp") {
          const array = [];
          localStorage.setItem("dp-src", url);
          firestore.doc(`users/${phone}`).update({
            dp: url,
          });

          //gets all audios ids(audio name) and updates there dp
          firestore
            .collection(`users/${phone}/audios`)
            .get()
            .then((docs) => {
              docs.forEach((snap) => {
                firestore.doc(`users/${phone}/audios/${snap.id}`).update({
                  dp: url,
                });
                firestore.doc(`users/${phone}/bucket/${snap.id}`).update({
                  dp: url,
                });
                //array gets the id to be used below
                array.push(snap.id);
              });

              //updates dp on my followers buckets
              const myRef = firestore.doc(`users/${phone}`);
              myRef.get().then((info) => {
                const followers = info.data().followers;
                followers.forEach((n) => {
                  array.forEach((audio) => {
                    const audioRef = firestore.doc(
                      `users/${n}/bucket/${audio}`
                    );
                    audioRef
                      .update({
                        dp: url,
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  });
                });
              });
            });

          alert("Nice your photo is added");
        }
        setUploadProgress(0);
      }
    );
  }

  const styling = {
    fontSize: "30px",
    heigth: "100px",
  };

  return (
    <div id="add-beats" className="flex-col-evenly">
      <span onClick={props.showState}>close</span>

      <div className="center flex-col">
        <div className="add-file-cont flex-col-left-center">
          <span>Add your audio or photo </span>

          <div className="add-btns flex-evenly">
            {tottalAudios ? (
              <span>reached maxmum</span>
            ) : (
              <label htmlFor="add-audio-btn">
                <FcMusic style={styling} />
              </label>
            )}

            <label htmlFor="add-dp-btn">
              <FcCamera style={styling} />
            </label>
          </div>

          {showUploadProgress && (
            <span className="upload-progress">{uploadProgress} % uploaded</span>
          )}

          <input
            style={{ display: "none" }}
            id="add-audio-btn"
            type="file"
            onChange={(e) => {
              addAudio(e);
            }}
          />
          <input
            style={{ display: "none" }}
            id="add-dp-btn"
            type="file"
            onChange={(e) => {
              addDp(e);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Addbeats;
